import API from '@/api/base'
import moment from 'moment'

export const state = {
  banners: [],
  currentBanner: null,
  scheduledBanner: null,
}

export const getters = {
  // Get all shop banners
  getBanners: ({ banners }) => banners,
  // Get current shop banner or null
  getCurrentBanner: ({ currentBanner }) => currentBanner,
  // Get currently schedule shop banner or null
  getScheduledBanner: ({ scheduledBanner }) => scheduledBanner,
  // Get boolean indicating if a banner is available to be displayed (current or scheduled)
  getBannerStatus: ({ currentBanner, scheduledBanner }) =>
    !!currentBanner || !!scheduledBanner,
}

export const actions = {
  fetchBanners: ({ commit, rootGetters, state }, slug) =>
    new Promise((resolve, reject) => {
      // return shop banners if already loaded
      if (state.banners.length > 0) {
        resolve()
      }
      API.findAll('shopBanner', {
        query: { site_id: rootGetters['sites/getSiteId'] },
        include: ['shop_item_category'],
      })
        .then((response) => {
          // Store banners into vuex
          commit('SET_BANNERS', response.data)
          // Filter out the currently selected banner, if present and store in vuex
          commit(
            'SET_CURRENT_BANNER',
            response.data.find((b) => b.current) || null
          )
          // Filter out the currently scheduled banner if present and store in vuex
          // Declare variable representing banner that is scheduled for the current time
          let currentlyScheduled = null
          // get only banners with `scheduled === true`
          const scheduled = response.data.filter((b) => b.scheduled)
          // If there's at least one scheduled banner
          if (scheduled.length > 0) {
            let start
            let end
            // iterate over scheduled banners
            for (const b of scheduled) {
              start = moment(b.scheduledStart, 'MM/DD/YYYY')
              end = moment(b.scheduledEnd, 'MM/DD/YYYY')
              // If NOW is between start and end dates of scheduled banner
              if (moment().isBetween(start, end, 'day', '[]')) {
                // return current banner
                currentlyScheduled = b
                break
              }
            }
          }
          commit('SET_SCHEDULED_BANNER', currentlyScheduled)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    }),
}

export const mutations = {
  SET_BANNERS(state, banners) {
    state.banners = banners
  },
  SET_CURRENT_BANNER(state, banner) {
    state.currentBanner = banner
  },
  SET_SCHEDULED_BANNER(state, banner) {
    state.scheduledBanner = banner
  },
}
